import Vue from 'vue';
import de from 'vuetify/lib/locale/de';
import { MANX_DESIGN_STYLEGUIDE_THEME } from '@sprengnetter/vue-cd-components/src/themes/themes';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: MANX_DESIGN_STYLEGUIDE_THEME,
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { de },
    current: 'de',
  },
});
